// extracted by mini-css-extract-plugin
export default {"container":"Settings_container__YwgxA","content":"Settings_content__XeHL-","menu":"Settings_menu__D8LVx"};